"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var digitalDataAssignment_1 = require("../../../../../../common/utilities/digitalDataAssignment");
var customDatalayerInterface_1 = require("../../../../../../common/utilities/customDatalayerInterface");
var buildSelectedSpecData_1 = require("../../utils/dataLayer/buildSelectedSpecData");
var customerStorage_1 = require("../../../../../../common/service/customerStorage");
var hashUtilities_1 = require("../../../../../../common/utilities/hashUtilities");
var useCallDigitalAssignmentEntryEvent = function () {
    var callDigitalAssignmentEntryEvent = function (_a) {
        var deal = _a.deal, dimensions = _a.dimensions, stage = _a.stage;
        return __awaiter(void 0, void 0, void 0, function () {
            var email, emailHashed, _b, email, phone, emailHashed, phoneHashed, postcode, dealer, err_1;
            var _c, _d;
            return __generator(this, function (_e) {
                switch (_e.label) {
                    case 0:
                        _e.trys.push([0, 6, , 7]);
                        if (!(stage === customDatalayerInterface_1.DataLayerFormStage.EMAIL_MY_CONFIGURATION_SUBMITTED)) return [3 /*break*/, 2];
                        email = deal.customer.email;
                        return [4 /*yield*/, hashUtilities_1.default.hashSHA256(email)];
                    case 1:
                        emailHashed = _e.sent();
                        digitalDataAssignment_1.default({
                            event: customDatalayerInterface_1.DataLayerEvent.FORM_NAVIGATE,
                            form: {
                                name: customDatalayerInterface_1.DataLayerFormName.CONFIGURATOR,
                                stage: customDatalayerInterface_1.DataLayerFormStage.EMAIL_MY_CONFIGURATION_SUBMITTED,
                            },
                            user: {
                                emailHashed: emailHashed || null,
                            },
                        });
                        return [2 /*return*/];
                    case 2:
                        if (!(stage === customDatalayerInterface_1.DataLayerFormStage.PAYMENT_METHOD)) return [3 /*break*/, 5];
                        _b = deal.customer, email = _b.email, phone = _b.phone;
                        return [4 /*yield*/, hashUtilities_1.default.hashSHA256(email)];
                    case 3:
                        emailHashed = _e.sent();
                        return [4 /*yield*/, hashUtilities_1.default.hashSHA256(phone)];
                    case 4:
                        phoneHashed = _e.sent();
                        postcode = (customerStorage_1.customerStorage.getCustomerData(dimensions) || {}).postcode;
                        dealer = (_c = deal) === null || _c === void 0 ? void 0 : _c.dealer;
                        digitalDataAssignment_1.default({
                            event: customDatalayerInterface_1.DataLayerEvent.FORM_NAVIGATE,
                            form: {
                                name: customDatalayerInterface_1.DataLayerFormName.CONFIGURATOR_STOCK_RESERVATION,
                                stage: customDatalayerInterface_1.DataLayerFormStage.PAYMENT_METHOD,
                                details: {
                                    configurator: {
                                        financeOption: deal.finance.type,
                                        selectedSpec: buildSelectedSpecData_1.default({ deal: deal, dimensions: dimensions }),
                                    },
                                },
                            },
                            user: {
                                emailHashed: emailHashed || null,
                                phoneHashed: phoneHashed || null,
                                postCode: postcode || null,
                                preferredDealership: ((_d = dealer) === null || _d === void 0 ? void 0 : _d.label) || null,
                            },
                        });
                        return [2 /*return*/];
                    case 5:
                        digitalDataAssignment_1.default({
                            event: customDatalayerInterface_1.DataLayerEvent.FORM_NAVIGATE,
                            form: {
                                name: customDatalayerInterface_1.DataLayerFormName.CONFIGURATOR_STOCK_RESERVATION,
                                stage: customDatalayerInterface_1.DataLayerFormStage.START,
                                details: {
                                    configurator: {
                                        selectedSpec: buildSelectedSpecData_1.default({ deal: deal, dimensions: dimensions }),
                                    },
                                },
                            },
                        });
                        return [3 /*break*/, 7];
                    case 6:
                        err_1 = _e.sent();
                        // eslint-disable-next-line no-console
                        console.log('DataLayer error', err_1);
                        return [3 /*break*/, 7];
                    case 7: return [2 /*return*/];
                }
            });
        });
    };
    return { callDigitalAssignmentEntryEvent: callDigitalAssignmentEntryEvent };
};
exports.default = useCallDigitalAssignmentEntryEvent;
